import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { a } from '@react-spring/three';
import { useSun } from './use-sun';
import { inRange } from '../utils/random';
import { DIRS } from '../utils/constants';
const SunHalo = ({ value, style }) => {
    const dir = useRef(1);
    const speed = useRef(Math.random() * 0.0001 * inRange(DIRS));
    const halo = useRef();
    useFrame(() => {
        if (!halo.current) {
            return;
        }
        if (halo.current.scale.x <= 0.9) {
            dir.current = -dir.current;
        }
        else if (halo.current.scale.x >= 1.1) {
            dir.current = -dir.current;
        }
        halo.current.scale.x += speed.current * dir.current;
        halo.current.scale.y += speed.current * dir.current;
    });
    return (React.createElement(a.mesh, { ref: halo, "material-opacity": style === null || style === void 0 ? void 0 : style.opacity, position: value.startpoint },
        React.createElement("circleGeometry", { attach: "geometry", args: [value.radius, 128] }),
        React.createElement("meshBasicMaterial", { attach: "material", transparent: true, color: value.color })));
};
const Sun = (props) => {
    var _a;
    const sun = useRef();
    const { halos, startpoint } = useSun(props);
    return (React.createElement(a.group, { scale: (_a = props.style) === null || _a === void 0 ? void 0 : _a.scale, ref: sun, position: startpoint }, halos.map((halo, index) => {
        return React.createElement(SunHalo, { key: index, value: halo, style: props.style });
    })));
};
export default Sun;
